export default {
    title: 'FORFAITS DÉCOUVERTE',
    section1: {
        heading: 'ACCÈS À DES CAISSES MIXTES',
        description: 'Les Membres ont accès à des caisses mixtes de façon mensuelle sélectionné par Boires. La possibilité d\'avoir des bouteilles en importation privée, sans devoir les acheter à la caisse complète!'
    },
    section2: {
        heading: 'PRIX PRÉFÉRENTIELS',
        description: 'Les forfaits découvertes vous permettent d\'avoir accès à des produits en importations privé à des prix préférentiels.'
    },
    section3: {
        heading: 'COMMENT ÇA MARCHE?',
        description: 'Tu veux découvrir de nouveaux vins, avoir accès à une caisse mixtes changeante ou tu ne sais juste pas quoi choisir dans notre liste de vins d\'artisan?  Le Forfait Découverte pour toi!<br/> Abonnement mensuel ou annuel. Tu as jusqu\'au premier lundi de chaque mois pour confirmer ta commande et tu sera livré le 2e mardi du mois.'
    },
    box1: {
        title: 'Forfait 1',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.',
        plan: '290',
        subscribe: 'S’abonner',
        time: '/mois'
    },
    box2: {
        title: 'Forfait 2',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.',
        plan: '380',
        subscribe: 'S’abonner',
        time: '/mois'
    },
    box3: {
        title: 'Forfait 3',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.',
        plan: '500',
        subscribe: 'S’abonner',
        time: '/an'
    },
    package: '3 FORFAITS DÉCOUVERTE',
    commitment: 'Sans engagement, stopper votre abonnement à tout moment.'
};
